<button mat-button>
  <mat-icon>arrow_back</mat-icon>
  <span [translate]="label"></span>
</button>
